import React from 'react';
import Header from '../header';
import Sidebar from '../sidebar';
import { Col } from 'react-bootstrap';
import { BodyContainer } from './styles';
import { Outlet } from 'react-router-dom';

const BaseLayout: React.FC = () => {
  return (
    <>
      <Header />
      <BodyContainer>
        <Sidebar />
        <Col className="p-4">
          <Outlet />
        </Col>
      </BodyContainer>
    </>
  );
};

export default BaseLayout;
